import { render, staticRenderFns } from "./GetDevList.vue?vue&type=template&id=04b4bf70&scoped=true&"
import script from "./GetDevList.vue?vue&type=script&lang=js&"
export * from "./GetDevList.vue?vue&type=script&lang=js&"
import style0 from "./GetDevList.vue?vue&type=style&index=0&id=04b4bf70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b4bf70",
  null
  
)

export default component.exports